(function(){
  var root=document.querySelector('[data-wicked-capture]');
  if(!root)return;
  var key='wickedCollectorCaptureUntil';
  var now=Date.now();
  var until=parseInt(localStorage.getItem(key)||'0',10);
  if(root.querySelector('[data-wicked-success]')){localStorage.setItem(key,String(now+31536000000));return;}
  if(until>now)return;
  var opened=false;
  function open(){if(opened)return;opened=true;root.classList.add('is-open');root.setAttribute('aria-hidden','false');var e=root.querySelector('input[type=email]');if(e)setTimeout(function(){e.focus();},120);}
  function close(){root.classList.remove('is-open');root.setAttribute('aria-hidden','true');localStorage.setItem(key,String(Date.now()+604800000));}
  root.querySelectorAll('[data-wicked-close]').forEach(function(el){el.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('is-open'))close();});
  setTimeout(open,12000);
  document.addEventListener('mouseout',function(e){if(e.clientY<=0)open();},{once:true});
})();